import { render } from "./Whois.vue?vue&type=template&id=6c4ed99a&lang=pug"
import script from "./Whois.vue?vue&type=script&lang=js"
export * from "./Whois.vue?vue&type=script&lang=js"

import exportComponent from "/home/apognu/code/personal/defcon/assets/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__